import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import store from '@/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleLeft, faLock, faPlayCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faAngleLeft, faLock, faPlayCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)

window.$ = require('jquery')
window.JQuery = require('jquery')
Vue.use(BootstrapVue)
Vue.config.productionTip = true
/*
  Clearing localstorage based on loged user and keepMe


if (performance.navigation.type != 1) {
	if (localStorage.getItem('keepMe') == 'false') {
		localStorage.removeItem('userData')
	}
}
*/

store.dispatch('CHECK_AUTH_ON_LOAD').then(() => {
	new Vue({
		el: '#app',
		store,
		render: (h) => h(App)
	})
})



// WEBPACK FOOTER //
// ./src/main.js